import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BoobleModalService } from 'booble-modal';

import { countries } from 'src/app/shared/utils/countries';
import { CountryDto } from 'src/app/domain/models/dto/country.dto';
import { AuthenticationService } from 'src/app/shared/services';
import { OrdersService } from 'src/app/shared/services/orders.service';

import { BankAccountDto } from 'src/app/domain/models/dto/bank-account.dto';
import { FinalitiesService } from 'src/app/shared/services/finalities.service';
import { FinalitiesDto } from 'src/app/domain/models/dto/finalities.dto';

import { CorporateAccountDto } from 'src/app/domain/models/dto/corporate-account.dto';
import { Moedas } from 'src/app/domain/constants/moeda.constant';
import { AdminOrderDetailModalComponent } from '../order-details-modal/admin-order-detail-modal.component';
import { InboundOrderDto } from 'src/app/domain/models/dto/inbound-order.dto';


declare const $: any;

@Component({
  selector: 'app-generate-invoice-modal',
  templateUrl: './admin-order-edit-modal.component.html',
  styleUrls: ['./admin-order-edit-modal.component.scss'],
})
export class AdminOrderEditModal implements OnInit {
  public loading: boolean;
  companyId: number;
  company: CorporateAccountDto;
  bankAccounts: BankAccountDto[];
  branchs: string[];
  countries: CountryDto[];
  finalities: FinalitiesDto[];
  private readonly notifier: NotifierService;
  orderForm: FormGroup;
  controlBranch: string = '.js-control-branch';
  controlCurrency: string = '.js-control-currency';
  controlAccount: string = '.js-control-account';
  controlCountry: string = '.js-control-country';
  controlFinality: string = '.js-control-finality';
  moedas = Moedas;

  set boobleModalData(value: InboundOrderDto) {
    this.orderForm.patchValue(value);
    this.company = value.corporateAccount;
    this.bankAccounts = [value.corporateAccount.bankAccount];
    this.branchs = [value.corporateAccount.cnpj];
    this.orderForm.controls['branch'].patchValue(value.corporateAccount.cnpj);
    this.orderForm.controls['corporateAccountId'].patchValue(this.company.id);
    this.orderForm.controls['currency'].patchValue(value.currency);
    this.orderForm.controls['finalityId'].patchValue(value.finality.id);
    this.orderForm.controls['account'].patchValue(this.bankAccounts[0].number);
    this.orderForm.controls['id'].patchValue(value.id);
  }

  get boobleModalData(): InboundOrderDto {
    return this.orderForm.value;
  }

  get orderFormControl() {
    return this.orderForm.controls;
  }

  get order(): any {
    const order = this.orderForm.value;
    return order;
  }

  getFinalityIndex() {
    if (this.boobleModalData?.finality)
      return this.finalities.indexOf(this.finalities.filter(x => x.id = this.boobleModalData.finality.id)[0]);
  }

  constructor(
    private fb: FormBuilder,
    private readonly router: Router,
    notifierService: NotifierService,
    private readonly route: ActivatedRoute,
    private readonly ordersService: OrdersService,
    private readonly finalitiesService: FinalitiesService,
    private readonly authService: AuthenticationService,
    private modalService: BoobleModalService
  ) {
    this.countries = countries;
    this.companyId = +this.authService.getCompanyId();
    this.notifier = notifierService;
    this.orderForm = fb.group({
      id: [''],
      description: ['', Validators.required],
      currency: ['', Validators.required],
      amount: ['', Validators.required],
      corporateAccountId: ['', Validators.required],
      finalityId: [null, Validators.required],
      companyName: ['', Validators.required],
      country: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      branch: ['', Validators.required],
      account: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.setControls();

    this.finalitiesService.get().subscribe((getResult) => {
      this.finalities = getResult.data;
    });

  }

  setControls() {
    $(this.controlBranch).select2({
      language: {
        noResults: function () {
             return "Sem resultados";
        }
    }
    });
    $(this.controlCurrency).select2({
      language: {
        noResults: function () {
             return "Sem resultados";
        }
    }
    });
    $(this.controlAccount).select2({
      language: {
        noResults: function () {
             return "Sem resultados";
        }
    }
    });
    $(this.controlCountry).select2({
      language: {
        noResults: function () {
             return "Sem resultados";
        }
    }
    });
    $(this.controlFinality).select2({
      language: {
        noResults: function () {
             return "Sem resultados";
        }
    }
    });

    let t = this;
    $(this.controlBranch).on('change', function () {
      t.changeBranchForm($(this).val());
    });
    $(this.controlCurrency).on('change', function () {
      t.changeCurrencyForm($(this).val());
    });
    $(this.controlAccount).on('change', function () {
      t.changeAccountForm($(this).val());
    });
    $(this.controlCountry).on('change', function () {
      t.changeCountryForm($(this).val());
    });
    $(this.controlFinality).on('change', function () {
      t.changeFinalityForm($(this).val());
    });
  }

  changeBranchForm(text: String) {
    this.orderForm.controls['branch'].patchValue(text);
  }

  changeCurrencyForm(text: String) {
    this.orderForm.controls['currency'].patchValue(text);
  }

  changeAccountForm(text: String) {
    this.orderForm.controls['account'].patchValue(
      text.substring(text.indexOf(' ') + 1)
    );
  }

  changeCountryForm(text: String) {
    this.orderForm.controls['country'].patchValue(
      text.substring(text.indexOf(' ') + 1)
    );
  }

  changeFinalityForm(text: String) {
    this.orderForm.controls['finalityId'].patchValue(
      text.substring(text.indexOf(' ') + 1)
    );
  }

  handleCopyinvoiceemail(e) {
    this.orderForm.controls['copyinvoiceemail'].patchValue(e.target.checked);
  }

  save() {
    this.loading = true;
    let order: any = {
      id: this.order.id,
      description: this.order.description,
      currency: this.order.currency,
      amount: this.order.amount,
      finalityId: this.order.finalityId,
      corporateAccountId: this.order.corporateAccountId,
      sender: {
        companyName: this.order.companyName,
        country: this.order.country,
        email: this.order.email,
      },
      receiver: {
        branch: this.order.branch,
        account: this.order.account,
      },
    };

    this.ordersService.editOrder(order).subscribe({
      next: (orderResult) => {
        this.notifier.notify('success', 'Ordem alterada com sucesso!');
        this.loading = false;
        this.closeModal();
        this.ordersService.updateOrderView();
      },
      error: (err) => {
        this.loading = false;
      },
    });
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

  goBack(order: InboundOrderDto) {
    this.modalService.present(AdminOrderDetailModalComponent, order);
  }
}
